var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowAside = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 40,
  viewBox: "0 0 10 40",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 8.08403e-07C2.70213e-06 20 4.5 33 10 40L4.45059e-06 40L2.70213e-06 20L0 8.08403e-07Z",
  fill: "currentColor"
})));
export { SvgArrowAside as ReactComponent };